<template>
<div class="sezione"  style="padding:0 8px;" >


<div class="yo-fixed-top" style="top:132px;z-index:999;">
<div class="row el-container" style="background:#fff;padding:16px 20px;">
   <div class="col s12">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="line-height: 36px;">
         <el-breadcrumb-item><span class="yo-text-bold yo-text-m">Uso steroidi prenatali per centro</span></el-breadcrumb-item>
         <el-breadcrumb-item><span class=" yo-text-m">EG {{gaweakDown}}-{{gaweakUp}} sett.</span></el-breadcrumb-item>
         <el-breadcrumb-item><span class="yo-text-m">Anno 2020</span></el-breadcrumb-item> 
         <!-- 
         <el-breadcrumb-item>
            <el-select v-model="anno" placeholder="Select"  v-on:change="makeanalisi" size="small" style="width:150px;">
               <el-option label="Anno 2020" :value="2020"></el-option>
               <el-option label="Anno 2019" :value="2019"></el-option>
            </el-select>
         </el-breadcrumb-item>
         -->
      </el-breadcrumb>
   </div>
</div>
</div>



<div  :style="'width:'+boxw+'px;height:'+boxh+'px;'" style="margin:40px 0;background-color:red; background-image:url('/images/funnel-plot/funnel-steroidi-2020.png');">
<div  :style="'width:'+(boxw-funnelsx-funneldx)+'px;height:'+(boxh-funnelbottom-funneltop)+'px;margin:0 0 0 '+funnelsx+'px;top:'+funneltop+'px;'" style="position: relative;">

<blockquote v-for="(itm, index) in dati" :key="index+'_'+itm.centro" :class="'_'+itm.centro+' '+((itm.numero/itm.denominatore)*100/maxh)+'_'">
<div v-if="$centro.profile.row.id!=itm.centro" :style="'left: calc('+itm.denominatore*100/maxw+'% - 5px);bottom: calc('+((itm.numero/itm.denominatore*realploth/maxh) - outsidebottom)+'px - 5px);background: #0F5890;position: absolute;width: 10px;height: 10px;border-radius: 12px;'"></div>
<div v-if="$centro.profile.row.id==itm.centro" :style="'left: calc('+itm.denominatore*100/maxw+'% - 8px);bottom: calc('+((itm.numero/itm.denominatore*realploth/maxh) - outsidebottom)+'px - 5px);background: red;position: absolute;width: 16px;height: 16px;border-radius: 18px;'"></div>
</blockquote>


<!--
   <div class="g-confidenza-m" :style="'left: 0; bottom: calc('+( (itm.numero/itm.denominatore*realploth) - outsidebottom )+'px - 5px); background: red; position: absolute; width: 10px; height: 10px; border-radius: 12px;'"></div>



   <div class="g-confidenza-m" style="left: calc(14.1509% - 5px); bottom: calc(0% - 5px); background: red; position: absolute; width: 10px; height: 10px; border-radius: 12px;"></div>

   <div class="g-confidenza-m" style="left: calc(15.09% - 10px);bottom: calc(35.64% - 5px);background: red;position: absolute;width: 10px;height: 10px;border-radius: 12px;"></div>
-->

</div>
</div>


</div>
</template>

<script>

export default {
components: {
   
},
data() {
   return {
      loading:{}


      ,gaweakDown:23
      ,gaweakUp:31

      ,boxw:'1380'
      ,boxh:'720'
      ,funneltop: 16
      ,funnelbottom: 31
      ,funnelsx: 50
      ,funneldx: 46

      ,maxw: 186
      ,maxh: 1
      ,minh: .4


      ,dati:[



         {centro:10040,numero:11,denominatore:16},
         {centro:10151,numero:6,denominatore:17},
         {centro:10130,numero:13,denominatore:17},
         {centro:10128,numero:15,denominatore:18},
         {centro:10141,numero:16,denominatore:18},
         {centro:10131,numero:13,denominatore:19},
         {centro:10087,numero:17,denominatore:20},
         {centro:10078,numero:16,denominatore:20},
         {centro:10110,numero:17,denominatore:20},
         {centro:10063,numero:18,denominatore:20},
         {centro:10047,numero:16,denominatore:21},
         {centro:10018,numero:20,denominatore:21},
         {centro:10082,numero:17,denominatore:22},
         {centro:10021,numero:15,denominatore:26},
         {centro:10140,numero:17,denominatore:27},
         {centro:10081,numero:23,denominatore:28},
         {centro:10124,numero:24,denominatore:29},
         {centro:10043,numero:26,denominatore:30},
         {centro:10103,numero:29,denominatore:32},
         {centro:10042,numero:26,denominatore:33},
         {centro:10028,numero:31,denominatore:33},
         {centro:10017,numero:29,denominatore:33},
         {centro:10060,numero:24,denominatore:33},
         {centro:10058,numero:28,denominatore:33},
         {centro:10067,numero:31,denominatore:35},
         {centro:10111,numero:26,denominatore:35},
         {centro:10091,numero:28,denominatore:36},
         {centro:10069,numero:25,denominatore:37},
         {centro:10104,numero:26,denominatore:38},
         {centro:10089,numero:37,denominatore:39},
         {centro:10065,numero:32,denominatore:39},
         {centro:10137,numero:37,denominatore:41},
         {centro:10123,numero:37,denominatore:42},
         {centro:10068,numero:39,denominatore:42},
         {centro:10116,numero:38,denominatore:43},
         {centro:10079,numero:39,denominatore:43},
         {centro:10134,numero:38,denominatore:43},
         {centro:10061,numero:41,denominatore:45},
         {centro:10100,numero:22,denominatore:46},
         {centro:10127,numero:34,denominatore:46},
         {centro:10145,numero:38,denominatore:47},
         {centro:10133,numero:31,denominatore:50},
         {centro:10031,numero:46,denominatore:50},
         {centro:10057,numero:45,denominatore:51},
         {centro:10109,numero:48,denominatore:51},
         {centro:10050,numero:49,denominatore:56},
         {centro:10085,numero:34,denominatore:57},
         {centro:10073,numero:52,denominatore:58},
         {centro:10019,numero:44,denominatore:60},
         {centro:10049,numero:53,denominatore:61},
         {centro:10062,numero:56,denominatore:62},
         {centro:10118,numero:64,denominatore:69},
         {centro:10036,numero:59,denominatore:70},
         {centro:10051,numero:44,denominatore:71},
         {centro:10083,numero:67,denominatore:77},
         {centro:10034,numero:54,denominatore:77},
         {centro:10075,numero:67,denominatore:78},
         {centro:10129,numero:73,denominatore:85},
         {centro:10025,numero:86,denominatore:87},
         {centro:10045,numero:83,denominatore:88},
         {centro:10035,numero:82,denominatore:91},
         {centro:10054,numero:93,denominatore:114},
         {centro:10044,numero:108,denominatore:121},
         {centro:10107,numero:118,denominatore:149},
         {centro:10046,numero:141,denominatore:154},
         {centro:10024,numero:129,denominatore:155},
         {centro:10114,numero:126,denominatore:165},
         {centro:10070,numero:133,denominatore:167},
         {centro:10029,numero:145,denominatore:186},


      ]









   }
},
created () {
},
methods: {

}, 
computed:{
   realploth(){
      return (this.boxh-this.funneltop-this.funnelbottom)/(this.maxh-this.minh)
   },
   outsidebottom(){
      return (this.boxh-this.funneltop-this.funnelbottom)/(this.maxh-this.minh)-(this.boxh-this.funneltop-this.funnelbottom)
   }

}
}
</script>


<style >

</style>
